/**
 * Axios instance for the marketing-partner backend.
 *
 * Hits the API directly using VITE_APP_API_URL as the origin — no Vite proxy.
 * The backend must therefore allow CORS from the frontend's origin.
 */

import axios from 'axios';
import { PARTNER_TOKEN_KEY } from './sessionCoordinator';

const partnerAxios = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
    withCredentials: false
});

partnerAxios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(PARTNER_TOKEN_KEY);
        // Don't attach the bearer to auth endpoints — they exchange credentials
        // for a fresh token and shouldn't see stale auth state.
        const isAuthEndpoint =
            config.url?.includes('/oauth/') || config.url?.includes('/signin/');
        if (token && !isAuthEndpoint) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default partnerAxios;
